import './PlaceLibrary.css';

function Clients({ user }) {
  if (!user) {
    return (
      <div className="library-container">
        <p>Please sign in to view clients.</p>
      </div>
    );
  }

  return (
    <div className="library-container">
      <h2>Clients</h2>
      <div className="empty-state">
        <p>This page is under construction. Client management features coming soon.</p>
      </div>
    </div>
  );
}

export default Clients;
